<h1 class="modal-header">Edit key status</h1>

<app-checkbox [(ngModel)]="keys.released" class="mb-6"
	>Keys have been released to purchaser</app-checkbox
>

<app-radio-group
	label="Keys are in possession of"
	type="compact"
	[items]="keysPossessionOptions"
	[(ngModel)]="keys.possession"
	class="mb-6"
	[disabled]="keys.released"
></app-radio-group>

<app-input
	label="Lockbox code"
	[(ngModel)]="keys.lockboxCode"
	[@openClose]
	[disabled]="keys.released"
	*ngIf="keys?.possession === KeysPossessions.LOCKBOX"
	class="mb-6"
></app-input>

<app-input
	label="Additional note"
	[(ngModel)]="keys.note"
	[disabled]="keys.released"
></app-input>

<footer class="flex justify-between mt-5">
	<app-button size="small" btn="secondary" (click)="close()">Cancel</app-button>
	<app-button size="small" (click)="save()">Save</app-button>
</footer>
